/**
 * A RE-OPENED SAVED QUESTION: today's run of its STORED invocation (spec §16.4
 * primitive 1, "Re-opening re-executes, so a saved question can never become a
 * stale contradictory figure").
 *
 * Until 2026-10-02 a click in the rail re-asked the question's LABEL to the
 * model as new free text, so the metric, params, dimensions and period that
 * were saved were never used: the model could answer with another metric or
 * another period, and every re-open cost a model turn. Now the click runs the
 * saved invocation (`GET …/saved-question/{id}/run`) and shows its figures with
 * no AI summary. Asking the agent about it is still one click, as an explicit
 * choice ("Ask the agent about this").
 *
 * `SavedRunView` (its own module) is PURE, so every state renders in a test
 * with no network; `SavedRunPanel` only wires the hook to it.
 */
import { useSavedQuestionRun } from '@/hooks/useAgentArtifacts';
import { SavedRunView } from './SavedRunView';

export function SavedRunPanel({
  id,
  label,
  onAsk,
  onClose,
}: {
  id: string;
  label: string;
  onAsk: (question: string) => void;
  onClose: () => void;
}) {
  const { run, loading, notFound, error, reload } = useSavedQuestionRun(id);
  return (
    <SavedRunView
      label={label}
      state={{ run, loading, notFound, error }}
      onRerun={reload}
      onAsk={() => onAsk(label)}
      onClose={onClose}
    />
  );
}
